module.exports = __webpack_public_path__ + "img/4_136.f10347d9.png";